import { cancelBareDialog, readEscapeChrome } from './chrome.ts';

export type EscapeOwner = {
  /** Return true when this scene consumed Escape. */
  onEscape: () => boolean;
};

let owner: EscapeOwner | null = null;
let ownerToken = 0;
let installed = false;

export function setEscapeOwner(next: EscapeOwner): number {
  ownerToken += 1;
  owner = next;
  return ownerToken;
}

/** Ignore a shutdown from a scene that is no longer the owner. */
export function clearEscapeOwner(token: number): void {
  if (ownerToken !== token) {
    return;
  }

  owner = null;
}

/**
 * Registered before `new Phaser.Game`, so this capture listener runs ahead of Phaser
 * and ahead of bubble-phase menu listeners. `stopImmediatePropagation` only when this
 * router consumes the key, so an open menu or colour picker still receives Escape.
 */
export function installEscapeRouter(): void {
  if (installed) {
    return;
  }

  installed = true;
  window.addEventListener('keydown', onEscapeKey, true);
}

function onEscapeKey(event: KeyboardEvent): void {
  if (event.key !== 'Escape' || event.repeat) {
    return;
  }

  const chrome = readEscapeChrome();

  if (chrome === 'defer') {
    return;
  }

  if (chrome === 'dialog') {
    if (cancelBareDialog()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }

    return;
  }

  if (!owner?.onEscape()) {
    return;
  }

  event.preventDefault();
  event.stopImmediatePropagation();
}
